import { QueryClient } from "@tanstack/react-query";
import agencyTeamQueries from "../../modules/agency-team/agency-team.queries";
import agencyMembersQueries from "../../modules/agencyMembers/agency-members.queries";
import administrativePaymentQueries from "../../modules/billing/administrative-payment.queries";
import botAgentQueries from "../../modules/bot-agent/bot-agent.queries";
import callCenterQueries from "../../modules/call-center/call-center.queries";
import caregiverQueries from "../../modules/caregiver/caregiver.queries";
import cicoIssuesQueries from "../../modules/cico-reports/utils/cicoIssues.queries";
import communicationQueries from "../../modules/communication/communication.queries";
import contractQueries from "../../modules/contract/contract.queries";
import customFieldQueries from "../../modules/custom-field/custom-field.queries";
import noteQueries from "../../modules/note/note.queries";
import officeQueries from "../../modules/office/office.queries";
import patientQueries from "../../modules/patient/patient.queries";
import patientIntakeQueries from "../../modules/patientIntake/patient-intake.queries";
import patientPhysicianQuesires from "../../modules/patientPhysician/patient-physicians.queries";
import payrollQueries from "../../modules/payroll/payroll.queries";
import telephonyQueries from "../../modules/telephony/telephony.queries";
import visitQueries from "../../modules/visit/visit.queries";
import workflowQueries from "../../modules/workflow/workflow.queries";
import patientTaskMetricsQueries from "../../modules/patientTasksMetrics/PatientTaskMetrics.queries";
import promptTestingQueries from "../../modules/prompt-testing/prompt-testing.queries";
import { API, createApi } from "../api";
import certificationsQueries from "../../modules/certification-broadcast-settings/certifications.queries";
import officeBranchQueries from "../../modules/office-branch/office-branch.queries";
import bankedMinutesQueries from "../../modules/billing/pages/banked-minutes/banked-minutes.queries";
import uploadsQueries from "../../modules/billing/pages/uploads/uploads.queries";
import serviceCodeQueries from "../../modules/service-code/service-code.queries";
import dailyNotesQueries from "../../modules/dailyNotes/daily-notes.queries";
import servicePlanQueries from "../../modules/servicePlan/service-plan.queries";
import agencyBillingQueries from "../../modules/billing/pages/agency-billing/agency-billing.queries";
import evvDutyCodeMappingQueries from "../../modules/evv-duty-code-mapping/evv-duty-code-mapping.queries";
import scheduledReportsQueries from "../../modules/scheduledReports/scheduledReports.queries";
import nursingQuestionSettingsQueries from "../../modules/nursingQuestionSettings/nursing-question-settings.queries";
import planOfCareTypeQueries from "../../modules/planOfCareType/plan-of-care-type.queries";
import reassignMissedDutyQueries from "../../modules/planOfCare/reassignMissedDuty.queries";
import authorizationUtilizationQueries from "../../modules/authorization-utilization/authorization-utilization.queries";
import pdfFormTemplateQueries from "../../modules/pdf-form-template/pdf-form-template.queries";
import aiWeeklyTemplateBuilderQueries from "../../modules/ai-weekly-template-builder/ai-weekly-template-builder.queries";
import rnSchedulingMapQueries from "../../modules/care-and-task-management/rn-scheduling-map/rn-scheduling-map.queries";
import documentReviewQueries from "../../modules/document-review/documentReview.queries";

export function createQueryGroup<GroupRecord extends Record<PropertyKey, unknown>>(
  factory: (p: { api: API }) => GroupRecord
) {
  return factory;
}

export function createQueries(params: {
  api: ReturnType<typeof createApi>;
  queryClient: QueryClient;
}) {
  const { api } = params;

  const groupParams = { api };

  return {
    note: noteQueries(groupParams),
    documentReview: documentReviewQueries(groupParams),
    agencyTeam: agencyTeamQueries(groupParams),
    certifications: certificationsQueries(groupParams),
    agencyMember: agencyMembersQueries(groupParams),
    communication: communicationQueries(groupParams),
    visit: visitQueries(groupParams),
    office: officeQueries(groupParams),
    officeBranch: officeBranchQueries(groupParams),
    contract: contractQueries(groupParams),
    workflow: workflowQueries(groupParams),
    intake: patientIntakeQueries(groupParams),
    callCenter: callCenterQueries(groupParams),
    telephony: telephonyQueries(groupParams),
    customField: customFieldQueries(groupParams),
    patient: patientQueries(groupParams),
    patientPhysician: patientPhysicianQuesires(groupParams),
    caregiver: caregiverQueries(groupParams),
    payroll: payrollQueries(groupParams),
    cicoIssues: cicoIssuesQueries(groupParams),
    administrativePayment: administrativePaymentQueries(groupParams),
    bankedMinutes: bankedMinutesQueries(groupParams),
    authorizationUtilization: authorizationUtilizationQueries(groupParams),
    aiWeeklyTemplateBuilder: aiWeeklyTemplateBuilderQueries(groupParams),
    uploads: uploadsQueries(groupParams),
    serviceCode: serviceCodeQueries(groupParams),
    servicePlan: servicePlanQueries(groupParams),
    dailyNotes: dailyNotesQueries(groupParams),
    agencyBilling: agencyBillingQueries(groupParams),
    botAgent: botAgentQueries(groupParams),
    patientTaskMetrics: patientTaskMetricsQueries(groupParams),
    promptTesting: promptTestingQueries(groupParams),
    evvDutyCodeMapping: evvDutyCodeMappingQueries(groupParams),
    scheduledReports: scheduledReportsQueries(groupParams),
    nursingQuestionSettings: nursingQuestionSettingsQueries(groupParams),
    planOfCareType: planOfCareTypeQueries(groupParams),
    reassignMissedDuty: reassignMissedDutyQueries(groupParams),
    pdfFormTemplate: pdfFormTemplateQueries(groupParams),
    rnSchedulingMap: rnSchedulingMapQueries(groupParams),
  };
}
